<template>
  <div class="Button"
    :is="tagType"
    :class="buttonClasses"
    v-bind="buttonAttributes">

    <div class="Button-icon"
      v-if="icon">

      <icon :name="icon" />

    </div>

    <div class="Button-label"
      v-if="label">
      {{ label }}
    </div>

    <div class="Button-meta"
      v-if="meta">
      {{ meta }}
    </div>
  </div>
</template>

<script>
/**
 * TODO:
 * - Clean this up now that the old tag-button, which called this, is removed.
 * - Tags are now their own component.
 */
export default {
  props: {
    label: {
      type: [String, Number]
    },
    route: {
      type: Object
    },
    link: {
      type: String
    },
    icon: {
      type: String
    },
    meta: {
      type: [String, Number]
    },
    disabled: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    iconOnRight: {
      type: Boolean,
      default: false
    },
    light: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    /**
     * Return appropriate tag for button type
     * @return {String}
     */
    tagType () {
      if (this.disabled) return 'div'

      // Handle standard link
      if (this.link) return 'a'

      // Handle internal route
      if (this.route) return 'router-link'

      return 'div'
    },

    /**
     * Button classes
     * @return {Array}
     */
    buttonClasses () {
      const classes = []

      if (this.label) classes.push('Button--hasLabel')
      if (this.light) classes.push('Button--isLight')
      if (this.small) classes.push('Button--isSmall')
      if (this.iconOnRight) classes.push('Button--iconOnRight')
      if (this.disabled) classes.push('Button--isDisabled')
      this.icon ? classes.push('Button--hasIcon') : classes.push('Button--noIcon')

      return classes
    },

    /**
     * Return appropriate attribute set for button type
     * @return {Object}
     */
    buttonAttributes () {
      if (this.disabled) return {}

      // Handle standard link
      if (this.link) return { href: this.link }

      // Handle internal route
      if (this.route) return { to: this.route }
    }
  }
}
</script>

<style>
@import 'properties';

.Button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 var(--unit);
  height: 42px;
  border: 0.5px solid var(--c-blue);
  border-radius: var(--radius);
  user-select: none;
  cursor: pointer;
  -webkit-font-smoothing: antialiased;
  text-decoration: none;
}

.Button--isDisabled {
  pointer-events: none;
}

.Button--isSmall {
  height: 30px;
}

.Button--hasIcon {
  padding: 0 var(--unit-05);
}

.Button:hover {
  background-color: var(--c-blue);
  /*border-color: var(--c-blue);*/
}

.Button-label {
  position: relative;
  top: 1px;
  font-size: 15px;
  line-height: 1;
  font-weight: 400;
  color: var(--c-blue);
  cursor: pointer;
}

.Button--isSmall .Button-label {
  font-family: var(--font-family-sans);
  font-size: 11px;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.125em;
}

.Button--noIcon .Button-label {
  font-family: var(--font-family-sans);
  font-size: 11px;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.125em;
}

.Button:hover .Button-label {
  color: var(--c-white);
}

.Button--hasLabel.Button--hasIcon .Button-icon {
  margin: 0 6px 0 0;
}

.Button--hasLabel.Button--iconOnRight.Button--hasIcon .Button-icon {
  order: 2;
  margin: 0 0 0 6px;
}

.Button:hover .Button-icon svg {
  fill: var(--c-white) !important;
}

.Button--isLight .Button-icon svg {
  fill: var(--c-blue) !important;
}

.Button-meta {
  position: relative;
  top: 1px;
  font-size: 15px;
  line-height: 1;
  font-weight: 400;
  color: var(--c-grey-lt);
}

.Button:hover .Button-meta {
  color: var(--c-black);
}
</style>



// WEBPACK FOOTER //
// ButtonComponent.vue?4028e880